import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';

import InlineAlert from 'app/commonComponents/InlineAlert';

// TODO https://developer.paypal.com/docs/checkout/integrate/#6-verify-the-transaction

class PayPalButtons extends Component {
  static propTypes = {
    style: PropTypes.object,
    purchaseUnits: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.object),
      PropTypes.func,
    ]),
    onError: PropTypes.func,
    onReady: PropTypes.func,
    onCancel: PropTypes.func,
    onProcessError: PropTypes.func,
    onProcessSuccess: PropTypes.func,
  };

  containerRef = createRef();

  async componentDidMount() {
    if (!window.paypal) {
      return;
    }
    const {
      style,
      purchaseUnits,
      onError,
      onReady,
      onCancel,
      onProcessError,
      onProcessSuccess,
    } = this.props;
    try {
      await window.paypal
        .Buttons({
          style,
          createOrder: (_, actions) =>
            actions.order.create({
              purchase_units:
                typeof purchaseUnits === 'function'
                  ? purchaseUnits()
                  : purchaseUnits,
            }),
          onCancel: (data, actions) => onCancel && onCancel(data, actions),
          onApprove: async (data, actions) => {
            if (data.orderID) {
              onProcessSuccess(data.orderID);
            } else {
              onProcessError();
            }
          },
        })
        .render(this.containerRef.current);
      if (onReady) {
        onReady();
      }
    } catch (error) {
      if (onError) {
        onError(error);
      }
    }
  }

  render() {
    return window.paypal ? (
      <div ref={this.containerRef} />
    ) : (
      <InlineAlert type="error">
        {i18n.gettext(
          'Error loading PayPal - please choose another payment method.'
        )}
      </InlineAlert>
    );
  }
}

export default PayPalButtons;
